import { render } from "./ModalNuevoUsuario.vue?vue&type=template&id=15fd9c9b"
import script from "./ModalNuevoUsuario.vue?vue&type=script&lang=js"
export * from "./ModalNuevoUsuario.vue?vue&type=script&lang=js"

import "./ModalNuevoUsuario.vue?vue&type=style&index=0&id=15fd9c9b&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__